import rajat from '../public/rajat.png'
import pratik from '../public/pratik.jpg'
export const GameDevelopment = [
    {
        id: 1,
        name: 'Rajat Vishwakarma  ',
        image_url:rajat,
        description : 'Game Development',       
    },
    {
        id:2,
        name:'Pratik Prajn',
        image_url: pratik,
        description:'Game Development'
    }
]
